
import { Coupon } from '../interfaces/Types';
import { PRODUCTS } from '../lib/constants/appConstants';
import { ConfigHelper } from './ConfigHelper';
import { AppConstants } from './AppConstants';
import { DiscountItem } from '../interfaces/Types';

export class DiscountHelper {
    static isCollectiveDiscountEnabled = (product: string) => product !== PRODUCTS.ACCIDENT && product !== PRODUCTS.PPI;

    static buildDiscountDetails = (product: string, channel: string, discountPercentage:number, couponInfo: Coupon): DiscountItem[] => {
        const campaignsList = ConfigHelper.getCampaignDetails(product, channel);
        const couponList = couponInfo.couponCode ? [
            {
              title: 'Rabattkod ' + couponInfo.couponCode.toUpperCase(),
              description: 'Giltig första året.',
              value: `${couponInfo.couponDiscountPercentage} %`
            }
          ] : [];
          const discountList = DiscountHelper.isCollectiveDiscountEnabled(product) ? [
            {
              title: AppConstants.getAppText('webshop.discount.percentage.label'),
              description: AppConstants.getAppText(
                'webshop.discount.helpText'
              ),
              value: `${discountPercentage} %`
            }
          ] : [];
          return [
            ...campaignsList,
            ...couponList,
            ...discountList
          ]
    };

}


